import { fileURLToPath } from 'url';
import { resolveModule } from '@ms-cloudpack/path-utilities';

/**
 * Resolve an import specifier for a parent config file.
 * Throws if it can't be resolved or doesn't exist.
 */
export function resolveParentConfig(params: {
  /** Path of the config file being processed. */
  configPath: string;
  /** The import specifier for the parent (extends) config file. */
  importSpecifier: string;
}): string {
  const { importSpecifier, configPath } = params;

  try {
    return fileURLToPath(resolveModule({ importSpecifier, parentPath: configPath }));
  } catch (err) {
    // The error message often includes the config path, so don't show it twice.
    const errorMessage = String((err as Error).message || err);
    const fromPathPart = errorMessage.includes(configPath) ? '' : ` from ${configPath}`;
    throw new Error(`Could not resolve "extends": "${importSpecifier}"${fromPathPart}:\n${errorMessage}`, {
      cause: err,
    });
  }
}
